const chapter1 = {
  title: '第一章  操作系统引论',
  article: [
    {
      title: '教学目的',
      contents: [
        '通过本章教学，使学生掌握计算机操作系统目标、作用、发展过程及发展的主要动力、操作系统的基本特征及功能、操作系统的结构设计。了解本门课程的教学要求和学习方法。'
      ]
    },
    {
      title: '重点难点',
      contents: [ '操作系统的特征和服务、操作系统的功能、操作系统的结构设计。' ]
    },
    {
      title: '教学内容',
      contents: [
        '1.1 操作系统目标和作用',
        '要点：操作系统的目标、作用、推动操作系统发展的主要动力。',
        '1.2 操作系统的发展过程',
        '要点：无操作系统时的计算机系统、单道批处理系统、多道批处理系统、分时系统、实时系统。',
        '1.3 操作系统的基本特性',
        '要点：操作系统的四大特征：并发、共享、 虚拟、 异步性。',
        '1.4 操作系统的主要功能',
        '要点：操作系统的五大功能：处理器管理的功能、存储器管理的功能、设备管理的功能、文件管理的功能、用户接口。',
        '1.5 操作系统的结构设计',
        '要点：软件工程的基本概念、传统的操作系统结构、微内核OS结构、指令的执行与中断。'
      ]
    },
    {
      title: '考核要点',
      contents: [
        '计算机操作系统发展的阶段、各阶段的特点及其对应的典型操作系统，操作系统和的五大基本功能及特征。'
      ]
    }
  ]
}

const chapter2 = {
  title: '第二章  进程的描述与控制',
  article: [
    {
      title: '教学目的',
      contents: [
        '通过本章教学，使学生掌握进程和线程的基本概念、进程同步和通信机制以及进程控制过程、经典进程的同步问题。'
      ]
    },
    {
      title: '重点难点',
      contents: [
        '进程的描述与控制、信号量机制、进程通信、进程同步算法。'
      ]
    },
    {
      title: '教学内容',
      contents: [
        '2.1 前趋图与程序执行',
        '要点：程序的顺序执行及其特征、前趋图、程序的并发执行及其特征。',
        '2.2 进程的描述',
        '要点：进程的特征与状态、进程控制块。',
        '2.3 进程控制',
        '要点：进程的创建、进程的终止、进程的阻塞与唤醒、进程的挂起与激活。',
        '2.4 进程同步',
        '要点：进程同步的基本概念、信号量机制、信号量的应用。',
        '2.5 经典进程的同步问题',
        '要点：生产者-消费者问题、信号量机制、经典进程同步问题、管程机制。',
        '2.6 进程通信',
        '要点：进程通信的类型、进程通信方式、消息缓冲机制、邮箱机制、进程通信的实例。',
        '2.7 线程的基本概念',
        '要点：线程的概念。',
        '2.8 线程的实现',
        '要点：线程的同步与通信、内核支持线程与用户级线程、线程控制。'
      ]
    },
    {
      title: '考核要点',
      contents: [
        '进程与线程的概念、进程控制、进程同步与通信、信号量机制。'
      ]
    }
  ]
}

const chapter3 = {
  title: '第三章  处理机调度与死锁',
  article: [
    {
      title: '教学目的',
      contents: [
        '本章的学习目的主要是使学生理解和掌握处理机调度和死锁的基本概念，要求掌握进程调度和常见的调度算法，掌握死锁的概念和产生的必要条件，掌握死锁的预防和避免方法，了解银行家算法.，死锁的检测及恢复。'
      ]
    },
    {
      title: '重点难点',
      contents: [
        '调度类型、调度算法、死锁的概念、死锁产生的必要条件、处理死锁的基本方法、安全状态、银行家算法、死锁的预防和避免、银行家算法、死锁的预防和避免。'
      ]
    },
    {
      title: '教学内容',
      contents: [
        '3.1 处理机调度的层次和调度算法的目标',
        '要点：高级、中级、低级调度、调度队列模型、调度算法的目标',
        '3.2 作业与作业调度',
        '要点：FCFS算法、FPF算法、基于时间片的轮转调度算法。',
        '3.3 进程调度',
        '要点：多处理机系统类型、进程分配方式、进程（线程）调度方式。',
        '3.4 实时调度',
        '要点：实现实时调度的基本条件、实时调度的算法分类、常用的几种实时调度算法。',
        '3.5 死锁概述',
        '要点：死锁产生的两个原因和四个必要条件。。',
        '3.6 预防死锁',
        '要点：破坏死锁产生的四个必要条件中的一个或多个。',
        '3.7 避免死锁',
        '要点：安全性检测、银行家算法。',
        '3.8 死锁的检测与解除',
        '要点：死锁定理、死锁的检测算法、死锁的解除。'
      ]
    },
    {
      title: '考核要点',
      contents: [
        '调度的基本概念、类型、调度算法、死锁的定义急处理方法。'
      ]
    }
  ]
}

const chapter4 = {
  title: '第四章  存储器管理',
  article: [
    {
      title: '教学目的',
      contents: [
        '通过本章的学习使学生了解程序的装入和链接，掌握内存的分配（连续分配、离散分配）及回收算法、内存保护、对换、分段和分页存储管理方式。'
      ]
    },
    {
      title: '重点难点',
      contents: [
        '动态分区分配、分页存储管理、分段存储管理。'
      ]
    },
    {
      title: '教学内容',
      contents: [
        '4.1 存储器的层次结构',
        '4.2 程序的装入和链接',
        '要点：程序的装入和链接方式，包括静态链接和动态链接。',
        '4.3 连续分配存储管理方式',
        '要点：四种连续分配方式：单一连续分配、固定分区分配、动态分区分配、可重定位动态分区分配。',
        '4.4 对换（Swapping）',
        '要点：对换的概念、对换空间的管理、进程的换入和换出。',
        '4.5 分页存储管理方式',
        '要点：页面与页表、地址变换机构、两级和多级页表。',
        '4.6 分段存储管理方式',
        '要点:分段存储管理方式的引入、分段系统的基本原理、信息共享、段页式存储管理方式。'
      ]
    },
    {
      title: '考核要点',
      contents: [
        '掌握内存的连续分配方式、离散分配方式、分页与分段存储管理。'
      ]
    }
  ]
}

const chapter5 = {
  title: '第五章  虚拟存储器',
  article: [
    {
      title: '教学目的',
      contents: [
        '通过本章的学习使学生了解虚拟存储器、页面置换算法。'
      ]
    },
    {
      title: '重点难点',
      contents: [
        '虚拟存储器的基本概念、请求分页存储管理方式、页面置换算法、请求分段存储管理方式。'
      ]
    },
    {
      title: '教学内容',
      contents: [
        '5.1 虚拟存储器概述',
        '要点：虚拟存储器的引入、实现方法、特征。',
        '5.2 请求分页存储管理方式',
        '要点：请求分页中的硬件支持、内存分配策略和分配算法、调页策略。',
        '5.3 页面置换算法',
        '要点：OPT算法、FIFO算法、LRU算法、Clock算法。',
        '5.4 “抖动”与工作集',
        '要点：抖动的概念。',
        '5.5 请求分段存储管理方式',
        '要点：请求分段中的硬件支持、分段的共享与保护。'
      ]
    },
    {
      title: '考核要点',
      contents: [
        '掌握虚拟存储器的概念、特征及实现。'
      ]
    }
  ]
}

const chapter6 = {
  title: '第六章  输入输出系统',
  article: [
    {
      title: '教学目的',
      contents: [
        '要求学生掌握四种I/O控制方式、设备分配算法、分配过程、以及缓冲管理、SPOOLING技术、设备处理、磁盘调度算法。'
      ]
    },
    {
      title: '重点难点',
      contents: [
        'I/O控制方式、缓冲管理、SPOOLING 原理、设备分配。'
      ]
    },
    {
      title: '教学内容',
      contents: [
        '6.1 I/O系统的功能、模型和接口',
        '要点：I/O系统的功能等。',
        '6.2 I/O设备和设备控制器',
        '要点：I/O设备的类型、设备控制器。',
        '6.3 中断机构和中断处理程序',
        '6.4 设备驱动程序',
        '要点：设备驱动程序的功能、特点、处理过程、中断处理程序的处理过程。',
        '6.5 与设备无关的I/O软件',
        '要点：设备分配中的数据结构、考虑的因素、设备分配程序、设备独立性',
        '6.6 用户层的I/O软件',
        '要点：SPOOLing技术',
        '6.7 缓冲区管理',
        '要点：缓冲的引入、缓冲的类型。',
        '6.8 磁盘存储器管理',
        '要点：磁盘性能简述、磁盘调度、磁盘高速缓存、提高磁盘I/O速度的其他方法。'
      ]
    },
    {
      title: '考核要点',
      contents: [
        '四种I/O控制方式、设备分配和设备处理过程、中断处理过程。'
      ]
    }
  ]
}

const chapter7 = {
  title: '第七章  文件管理',
  article: [
    {
      title: '教学目的',
      contents: [
        '要求学生掌握文件的逻辑结构和物理结构、目录管理、文件存储空间的管理、文件共享与保护、外存分配方法、空闲存储空间的管理、磁盘容错技术、文件系统性能的改善、数据一致性控制。'
      ]
    },
    {
      title: '重点难点',
      contents: [
        '文件结构、目录管理、文件共享、外存分配方法、空闲存储空间的管理。'
      ]
    },
    {
      title: '教学内容',
      contents: [
        '7.1 文件的文件系统',
        '要点：文件、记录、数据项的基本概念、文件类型、文件系统模型、文件操作。',
        '7.2 文件的逻辑结构',
        '要点：文件逻辑结构的类型、顺序文件、索引文件、顺序索引文件、直接文件、哈西文件。',
        '7.3 外存分配方式',
        '要点：连续分配、连接分配、索引分配。',
        '7.4 目录管理',
        '要点：FCB和索引结点、目录结构、目录查询技术。',
        '7.5 文件存储空间的管理',
        '要点：管理方式：空闲表法、空闲链表法、位示图法、成组链接法。',
        '7.6 文件共享与保护',
        '要点：利用索引结点的共享方式、利用符号链实现文件共享。',
        '7.7 数据一致性控制',
        '要点：事务、检查点、并发控制、重复数据的一致性问题。'
      ]
    },
    {
      title: '考核要点',
      contents: [
        '文件系统的基本概念、目录管理、文件存储空间的管理、文件的共享与保护。'
      ]
    }
  ]
}

const chapter8 = {
  title: '第八章  操作系统接口',
  article: [
    {
      title: '教学目的',
      contents: [
        '要求学生掌握操作系统提供的3种接口类型，每种接口类型的实现、原理、UNIX系统调用。'
      ]
    },
    {
      title: '重点难点',
      contents: [
        '接口的类型、功能、实现。'
      ]
    },
    {
      title: '教学内容',
      contents: [
        '8.1 联机命令接口',
        '要点：联机命令的类型、命令解释程序、键盘终端处理程序。',
        '8.2 SHELL命令语言',
        '要点：简单命令、通信命令、后台命令。',
        '8.3 系统调用',
        '要点：系统调用的基本概念、类型、实现。',
        '8.4 UNIX系统调用',
        '要点：UNIX系统调用的类型、系统调用陷入后需处理的若干问题。',
        '8.5 图形用户接口',
        '要点：桌面、图标、任务栏、窗口、对话框。'
      ]
    },
    {
      title: '考核要点',
      contents: [
        '接口的类型、功能、实现。'
      ]
    }
  ]
}

export default {
  chapter1,
  chapter2,
  chapter3,
  chapter4,
  chapter5,
  chapter6,
  chapter7,
  chapter8
};



// WEBPACK FOOTER //
// ./src/const/DPointData.js